import React, { Component } from 'react';
import { Confirm, Alert } from '../../../js/ComponentManager'
import { Big3Common, bootstrap } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:회원탈퇴 페이지
 * 세부설명:
*/

export class Withdrawal extends Component {
    static displayName = Withdrawal.name;

    constructor(props) {
        super(props);
        this.state = {
            Title:"",
            checkWithdraw: false,
            RegisterSuccess: false    //회원수정 완료
        };
        this.handle_Change = this.handle_Change.bind(this);
        this.handle_Confirm = this.handle_Confirm.bind(this);
    }
    handle_Change(event) {
        const target = event.target;
        let checked = target.checked;
        this.setState({ checkWithdraw: checked });
    }
    handle_Confirm() {
        if (this.state.checkWithdraw) {
            Big3Common.ModalAlert(bootstrap, 'ConfirmBox');
        }
        else {
            this.setState({ Title: "회원 탈퇴 확인을 체크해 주세요." });
            Big3Common.ModalAlert(bootstrap, 'AlertBox');
        }
        return false;
    }
    async handleWithdraw_Click() {
        let data = await Big3Common.Get("api/Account/MemberMgr/RegisterWithdraw");
        if (data.codeName === Big3Common.ResultCode.Success) {
            this.setState({ Title: data.message, RegisterSuccess: true });
        }
        else {
            this.setState({ Title: data.message});
        }
        Big3Common.ModalAlert(bootstrap, 'AlertBox');
    }
    //초기화
    componentDidMount() {
    }
    
    render() {
        return (
            <div>
                <div className="container_box p_b_margin c_padding">
                    <div className="Withdrawal_txt">탈퇴 전 반드시 확인 부탁드려요.</div>
                    <div className="Withdrawal_list">
                        <ul>
                            <li>거래정보가 있는 경우, 전자상거래 등에서의 소비자
                                보호에 관한 법률에 따라 계약 또는 청약철회에 관한
                                기록, 대금결제 및 재화 등의 공급에 관한 기록은
                                5년 동안 보존됩니다.</li>
                            <li>거래처에 보낸 메시지 등 일부 정보는 남아있을 수
                                있습니다.</li>
                            <li>클로디 서비스를 탈퇴하여도 기존 거래가 무효화되지 않습니다.</li>
                            <li>계정이 삭제된 후에는 계정을 살리거나 새로운 계정에 기존 데이터를 복구할 수 없습니다.</li>

                        </ul>
                    </div>
                    <div className="alarm_check">
                        <input className="form-check-input"
                            type="checkbox"
                            checked={this.state.checkWithdraw}
                            onChange={this.handle_Change}
                            
                        />
                        <label className="form-check-label">
                            확인했습니다
                        </label>
                    </div>
                </div>
                <div className="catagory_button_box">
                    <button type="button" className="btn_v btn_v1" onClick={this.handle_Confirm}>탈퇴하기</button>
                </div>
                <Confirm
                    id="ConfirmBox"
                    title="정말로 탈퇴 하시겠습니까?"
                    ConfirmClick={() => {
                        setTimeout(() => {
                            Big3Common.ModalClose(bootstrap, 'ConfirmBox');
                        }, 500);
                        this.handleWithdraw_Click()
                    }}
                />
                <Alert
                    id="AlertBox"
                    title={this.state.Title}
                    AlertClick={() => {
                        if (this.state.RegisterSuccess === true) {
                            window.location.href = "/Account/LoginMgr/Index";
                        }
                    }}

                />
            </div>
        );
    }
}
